import {GitMergeQueueIcon} from '@primer/octicons-react'

import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function QueuedStatusIcon({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.Queued) return null

  return <GitMergeQueueIcon size={12} className="color-fg-attention" aria-label="Merge status" />
}
